import { Pipe, PipeTransform } from '@angular/core';

interface InventoryFilterItem {
  Material: string;
  Description: string;
}

@Pipe({
  name: 'inventoryFilter',
  standalone: false,
})
export class InventoryFilterPipe implements PipeTransform {
  transform(
    value: InventoryFilterItem[] | undefined,
    args: string
  ): InventoryFilterItem[] | undefined {
    if (!args) return value;
    const filter = args.toLocaleLowerCase();
    return filter
      ? value.filter(
          (inventory) =>
            inventory.Material.toLocaleLowerCase().indexOf(filter) !== -1 ||
            inventory.Description.toLocaleLowerCase().indexOf(filter) !== -1
        )
      : value;
  }
}
